import { View } from "react-native";
import { FileText, Pencil } from "lucide-react-native";
import { EmptyState, CompactActionButton, DialogIcon } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";
import { MEDICAL_DEDUCTION_TAX_YEAR } from "@src/packages/costs/medicalExpenseDeduction";

const TAX_DEDUCTION_ILLUSTRATION =
  require("../../../assets/images/tax-deduction-recap.png") as number;

type Props = {
  subtitle?: string;
  onOpenTaxInputs?: () => void;
  onOpenTaxReview?: () => void;
};

export default function TaxDeductionPotentialEmptyState({
  subtitle,
  onOpenTaxInputs,
  onOpenTaxReview,
}: Props) {
  const t = useTranslations();

  return (
    <EmptyState
      density="compact"
      titleVariant="featured"
      illustration={
        <DialogIcon
          source={TAX_DEDUCTION_ILLUSTRATION}
          width={68}
          height={80}
        />
      }
      title={t("costs.tax_review.see_potential_tax_year_deduction", {
        params: { tax_year: String(MEDICAL_DEDUCTION_TAX_YEAR) },
      })}
      subtitle={subtitle ?? t("costs.tax_review.add_agi_to_compare_expenses")}
      action={
        onOpenTaxInputs ? (
          <View
            style={{
              flexDirection: "row",
              gap: 8,
              width: "100%",
              alignSelf: "stretch",
              flexWrap: "wrap",
            }}
          >
            <CompactActionButton
              label={t("costs.tax_review.add_tax_inputs")}
              action="costs.tax_review.add_tax_inputs"
              variant="primary"
              onPress={onOpenTaxInputs}
              leadingIcon={Pencil}
              flexGrow={1}
              flexBasis={130}
            />
            {onOpenTaxReview ? (
              <CompactActionButton
                label={t("costs.tax_review.tax_review_action")}
                action="costs.tax_review.tax_review_action"
                variant="secondary"
                onPress={onOpenTaxReview}
                leadingIcon={FileText}
                flexGrow={1}
                flexBasis={130}
              />
            ) : null}
          </View>
        ) : undefined
      }
      style={{
        width: "100%",
        paddingVertical: 6,
        paddingHorizontal: 0,
      }}
    />
  );
}
